const getFilterFloatChars = strValue => {
   if (!strValue) {
      return '';
   } else {
      return strValue.replace(/[^(\d|.)]/g, '');
   }
};

/*
      Adds 00 to fill
 */
export const floatStringToIntString = (floatStr) => {
   let intStr = '';
   // const floatStr = getFilterFloatChars(dirtyFloatStr);
   if (!floatStr) {
      intStr = '000';
   } else if (floatStr && typeof floatStr === 'string' && floatStr.indexOf('.') > -1) {
      intStr = parseFloat(floatStr).toFixed(2).toString().replace('.', '');
   } else if (typeof floatStr === 'string') {
      intStr = floatStr + '00';
   }
   return intStr;
};

/*
      INPUT    string of ONLY int
      OUTPUT   converts int to string currency format with decimal place to the tenth place
               removes tailing zero in front

      EXAMPLE:
         INPUT    "1234"
         OUTPUT   "12.34"

         INPUT    "-1234"
         OUTPUT   "-12.34"

         need to add decimal places if there isnt any
         need to round up if the precision is high
 */
export const intStringToCurrencyString = (intStr) => {
   if (!intStr) {
      return '';
   } else {
      let formattedStr = parseInt(intStr).toString();
      let hasNegativePrefix = false;

      if (parseInt(intStr) < 0) {
         hasNegativePrefix = true;
         formattedStr = formattedStr.slice(1);
      }

      while (formattedStr.length < 3) {
         formattedStr = `0${ formattedStr }`;
      }

      let currencyString = `${ formattedStr.substring(0, formattedStr.length - 2) }.${ formattedStr.substring(formattedStr.length - 2) }`;

      if (hasNegativePrefix) {
         currencyString = `-${ currencyString }`;
      }

      return currencyString;
   }
};

/*
      EXTENDS intStringToCurrencyString

      INPUT    string of ONLY int
      OUTPUT   converts string-integer to string currency format with decimal point placed before the integer on the tenth place
               with proper comma placements

      EXAMPLE:
         INPUT    "1234"
         OUTPUT   "$12.34"

      EXAMPLE:
         INPUT    ""
         OUTPUT   ""
 */
export const intStringToCurrencyDisplay = (intStr) => {
   const currencyStr = intStringToCurrencyString(intStr);

   if (!currencyStr) {
      return '';
   }
   const [numStr, decimal] = currencyStr.split('.');

   let hasNegativePrefix = false;
   let wholeNum = numStr;
   if (numStr && numStr.length > 0 && numStr[0] === '-') {
      hasNegativePrefix = true;
      wholeNum = numStr.slice(1);
   }

   let currencyDisplay;
   if (wholeNum.length < 3) {
      currencyDisplay = `${ wholeNum }.${ decimal }`;
   } else {
      let formattedWholeNum = `${ wholeNum.slice(wholeNum.length - 3) }`;
      for (let end = wholeNum.length - 3; end > 0; end -= 3) {
         const start = Math.max(end - 3, 0);
         const valToAppend = wholeNum.slice(start, end);

         formattedWholeNum = `${ valToAppend },${ formattedWholeNum }`;
      }
      currencyDisplay = `${ formattedWholeNum }.${ decimal }`;
   }

   if (hasNegativePrefix && currencyDisplay) {
      currencyDisplay = `-$${ currencyDisplay }`;
   } else if (currencyDisplay) {
      currencyDisplay = `$${ currencyDisplay }`;
   }
   return currencyDisplay;
};
